import React from 'react';
import styled from 'styled-components';
import { useFavorites } from '../context/FavoritesContext';

const QuoteCard = ({ quote }) => {
  console.log('QuoteCard received quote:', quote);

  const { toggleFavorite, isFavorite } = useFavorites();

  // Make sure quote is an object with required properties
  if (!quote || typeof quote !== 'object') {
    return (
      <CardContainer>
        <QuoteText>Error: Invalid quote data</QuoteText>
      </CardContainer>
    );
  }

  // Use either _id or id for compatibility with both API and local data
  const quoteId = quote._id || quote.id;
  const favorited = isFavorite(quoteId);

  return (
    <CardContainer>
      <QuoteText>"{quote.text}"</QuoteText>
      <QuoteAuthor>— {quote.author}</QuoteAuthor>
      <FavoriteButton
        onClick={(e) => {
          e.stopPropagation();
          toggleFavorite(quote);
        }}
        favorited={favorited}
        aria-label={favorited ? "Remove from favorites" : "Add to favorites"}
      >
        {favorited ? "★" : "☆"}
      </FavoriteButton>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  border-radius: 10px;
  background: linear-gradient(145deg, #1a1a1a, #0a0a0a);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.4);
  }
`;

const QuoteText = styled.p`
  font-family: var(--font-primary);
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.4;
  color: var(--color-text);

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const QuoteAuthor = styled.p`
  font-family: var(--font-secondary);
  font-size: 1.2rem;
  text-align: right;
  width: 100%;
  color: var(--color-primary);

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const FavoriteButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: ${props => props.favorited ? '#d4af37' : 'var(--color-secondary)'};
  font-size: 1.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    color: #d4af37;
    transform: scale(1.2);
  }

  &:focus {
    outline: none;
  }
`;

export default QuoteCard;
